import * as React from "react";

import { assertNever } from "@impero-com/common/utils/obj";

import {
    Month,
    SchedulingOccurrenceChangeForDueDateOffsetForMonthOffsetPeriod as SchedulingOccurrenceChange,
} from "api/generated/model";
import { translateMonth, translateMonthShort } from "org/control/list/utils";

import { GenericCustomDueDatesModal } from "../common/genericCustomDueDatesDialog";
import { GenericOccurrencesArray } from "../common/rulesWithArrays";
import { CustomDueDatesTypedProps } from "../types";

const ALL_OCCURRENCES: Month[] = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

type MonthlyCustomDueDatesModalProps = CustomDueDatesTypedProps<Month> & {
    initialCurrentOccurrences: GenericOccurrencesArray<Month>;
};

class MonthlyCustomDueDatesModal extends React.Component<MonthlyCustomDueDatesModalProps> {
    onChange = (
        currentOccurrences: Partial<Record<Month, SchedulingOccurrenceChange>>
    ) => {
        if (this.props.type !== "EDIT") {
            throw new Error("not editable");
        }
        const { onChange } = this.props;
        ALL_OCCURRENCES.forEach((occurrence) => {
            const change = currentOccurrences[occurrence];
            if (change !== undefined) {
                onChange(occurrence, change);
            }
        });
    };

    render = () => {
        const { type, initialCurrentOccurrences } = this.props;

        let typedProps;
        switch (type) {
            case "EDIT": {
                typedProps = {
                    type: "EDIT" as const,
                    onChange: this.onChange,
                };
                break;
            }
            case "READ_ONLY": {
                typedProps = {
                    type: "READ_ONLY" as const,
                };
                break;
            }
            default: {
                return assertNever(type);
            }
        }

        return (
            <GenericCustomDueDatesModal<Month>
                {...typedProps}
                initialCurrentOccurrences={initialCurrentOccurrences}
                allOccurrences={ALL_OCCURRENCES}
                translateOccurrence={translateMonth}
                translateOccurrenceShort={translateMonthShort}
                interval={"Month"}
            />
        );
    };
}

export { MonthlyCustomDueDatesModal };
